// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"1f0ba4cc","171":"abcde4ad","278":"12a09486","350":"29bc5a38","453":"cadb8f9c","687":"8ce09f25","928":"b4bbef53"}[chunkId] + ".chunk.js";
};